import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fpqcwkn7v8: FaireBrandEntity = {
  token: "b_fpqcwkn7v8",
  type: "brand",
  name: "66DISCO",
  avatarUrl:
    "https://cdn.faire.com/fastly/f0bff57b916f470d0bb7842bf1e484bb501bc87fb425f75dc69366594d26b14e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1b0fa563561ec744950add6462dd7fbe25923c3326db89d43d54350337f04ca0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f0bff57b916f470d0bb7842bf1e484bb501bc87fb425f75dc69366594d26b14e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1b0fa563561ec744950add6462dd7fbe25923c3326db89d43d54350337f04ca0.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.8,
  reviewCount: 349,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to 66DISCO! 🎉 Inspired by the woman who is confident, free-spirited, and fun-loving; 66DISCO was created to amuse her with stylish yet comfortable clothing to complement her lifestyle.\n\nFounded in Los Angeles by two sisters with a mission to provide the finest quality of products at affordable prices. We pride ourselves on making trendy yet timeless pieces focused on modesty while still keeping a playful edge. We embrace all female body types, making sure you feel beautiful and loved. 💖\n\nOur customers are our top priority! We hope you enjoy our products as much as we enjoy making them for you. If you have any questions or issues after receiving your order, please don’t hesitate to reach out!\n\n📌 PLEASE NOTE:\n\n🏷 Labels: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options.\n\n📦 Order Processing: Typically 2-4 business days. Fulfillment time: 7-11 days.\n\n🚚 Shipping: All orders are shipped from CA. \n\n⏰ Operation Hours: Monday - Friday, 9 AM - 5 PM PST.\n\nNeed more information or expedited shipping? Just contact us~!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:55.688Z",
    importedBy: "entity-db-cli",
  },
};
